import React from 'react';
import SearchSection from '../components/sections/SearchSection';

const SearchColleges = () => {
    return (
        <div className="min-h-screen bg-[#1a0b2e] pt-32 pb-20">
             <div className="max-w-7xl mx-auto px-4">
                <h1 className="text-4xl font-bold text-center mb-2 gradient-text">Find Your Dream College</h1>
                <p className="text-center text-text-muted mb-12">Explore universities, courses, and eligibility criteria</p>
                
                {/* Reusing your existing robust Search Component */}
                <SearchSection />
             </div>
        </div>
    );
};

export default SearchColleges;